import { Outlet } from 'react-router-dom';
import { WithFloationgBox } from '../etc/LBox/LBox';

const Conditions = () => {
  return (
    <>
      <Outlet />
      <WithFloationgBox />
    </>
  );
};

export default Conditions;
